var map = {
	"./active.svg": "206e",
	"./add.svg": "82bb",
	"./arrow-down.svg": "36fd",
	"./arrow-up.svg": "3748",
	"./assessment.svg": "cd63",
	"./calendar.svg": "ba24",
	"./chevron-down.svg": "1c3d",
	"./chevron-left.svg": "b4d9",
	"./chevron-right.svg": "eb33",
	"./client.svg": "5c6e",
	"./close.svg": "457c",
	"./cloud-upload.svg": "96bf",
	"./coupon.svg": "ae99",
	"./delete.svg": "71e6",
	"./disabled.svg": "5dd7",
	"./dk.svg": "2c31",
	"./edit.svg": "74ee",
	"./email.svg": "897c",
	"./eye-closed.svg": "e069",
	"./eye.svg": "9f95",
	"./father.svg": "7a4a",
	"./female.svg": "f59c",
	"./followup.svg": "a825",
	"./home.svg": "5cfd",
	"./like.svg": "dfb1",
	"./linkedin.svg": "6181",
	"./loader.svg": "2190",
	"./logo-grayscale.svg": "fc78",
	"./logo.svg": "3c8c",
	"./logout.svg": "9eef",
	"./magnifier.svg": "5792",
	"./male.svg": "d77c",
	"./manageprofile.svg": "6725",
	"./members.svg": "2ac1",
	"./message.svg": "faa0",
	"./mother.svg": "9e68",
	"./notify.svg": "7ddc",
	"./orderanalysis.svg": "95dc",
	"./pdf.svg": "45e8",
	"./pending.svg": "c910",
	"./phone.svg": "7780",
	"./profile-icon.svg": "a77b",
	"./profile.svg": "6e39",
	"./refresh.svg": "623b",
	"./reports.svg": "ee77",
	"./role.svg": "f6ee",
	"./search.svg": "ea5c",
	"./site.svg": "f36f",
	"./survey.svg": "ad84",
	"./tag.svg": "c494",
	"./twitter.svg": "541d",
	"./user.svg": "302a",
	"./viewreports.svg": "2534"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32a0";